<template>
    <div class="mb-5">
        <div class="splide">
            <div class="splide__track">
                <ul class="splide__list">
                    <li class="splide__slide">
                        <img class="w-full" src="https://buzzebees.blob.core.windows.net/dashboard/23a6382b-0daf-4de7-b7fa-f1be22d014e0">
                    </li>
                    <li class="splide__slide">
                        <img class="w-full" src="https://buzzebees.blob.core.windows.net/dashboard/23a6382b-0daf-4de7-b7fa-f1be22d014e0">
                    </li>
                    <li class="splide__slide">
                        <img class="w-full" src="https://buzzebees.blob.core.windows.net/dashboard/23a6382b-0daf-4de7-b7fa-f1be22d014e0">
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import Splide from '@splidejs/splide'; //https://splidejs.com/

export default {
    name: "ImageSlider",
    mounted: function() {
        new Splide('.splide', {
            type   : 'loop',
        }).mount();
    },
}
</script>

